import axios from 'axios';
import moment from "moment";

import {parameters} from "../parameters";

const httpClient = axios.create();

import {USER_TOKEN, TOKEN_TYPE, EXPIRES_IN} from "../store/modules/user/constants";

const authInterceptor = config => {
    if(isTokenValid()){

        config.headers = {
            'Authorization': `Bearer ${localStorage.getItem(USER_TOKEN)}`,
            'x-api-key': config.url.includes('referential') ? parameters.xapikeyRef : parameters.xapikey
        };
    } else {
        location.replace(`${parameters.fedUrl}/as/authorization.oauth2?client_id=${parameters.clientId}&response_type=code&redirect_uri=${parameters.redirectUri}&scope=openid%20profile%20email&code_challenge=` + localStorage.getItem("codeChallenge") + `&code_challenge_method=plain`);
    }
    return config;
};

const isTokenValid = () => {
    return localStorage.getItem(USER_TOKEN) && localStorage.getItem(TOKEN_TYPE) && localStorage.getItem(EXPIRES_IN) &&
        moment().isBefore(moment(localStorage.getItem(EXPIRES_IN)))
};

httpClient.interceptors.request.use(authInterceptor);

httpClient.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        return Promise.reject(error);
    }
);

export { httpClient, isTokenValid };